import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, ChangeDetectorRef, HostListener } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ColumnOrder } from '@core/table/order';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { NzTableSortOrder } from 'ng-zorro-antd/table';
import {
  SortCriterion,
  applyColumnSort,
  columnSortOrder,
  columnSortPriority,
  sortQueryParams
} from '@shared/util/multi-sort';
import * as FileSaver from 'file-saver';
import { ActivatedRoute, Router } from '@angular/router';
import { EntidadesService } from '@core/services/entidades.service';
import { EntidadeElement, EntidadeFiltro, TipoEntidadeEnum } from '@core/models/entidade';
import { DialogService } from '@core/services/dialog.service';
import { MessageService } from '@core/services/message.service';
import { NgxPermissionsService } from 'ngx-permissions';

import { NzButtonSize } from 'ng-zorro-antd/button';
import { ModalOptions, NzModalService } from 'ng-zorro-antd/modal';
import { AppSignalDataService } from 'src/app/app-signal-data.service';
import { EntidadeSharedDataService } from '../../entidade-shared-data.service';
import { StatusEntidadeService } from '@core/services/status.entidade.service';
import { PessoaService } from '@core/services/pessoa.service';
import { GrupoEconomicoService } from '@core/services/grupoeconomico.service';
import { TipoEntidadeService } from '@core/services/tipoentidade.service';
import { SituacaoEntidadeService } from '@core/services/situacaoentidade.service';
import { catchError, debounceTime, distinctUntilChanged, finalize, map, switchMap } from 'rxjs/operators';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { JustificativaModalComponent } from '../justificativa-modal/justificativa-modal.component';
import { TipoOrgaoService } from '@core/services/tipoorgao.service';
import { TipoComissaoService } from '@core/services/tipocomissao.service';
import { PerfilEnum } from '@core/models/perfil';
import { RoleEnum } from '@core/models/role';
import { GrupoAtualizacaoService } from '@core/services/grupo-atualizacao.service';
import { TipoAssociacaoService } from '@core/services/TipoAssociacaoService';
import { DominiosService } from '@core/services/dominios.service';
import { VinculoService } from '@core/services/vinculo.service';
import { ModalErro409Component } from '@shared/components/modal-erro-409/modal-erro-409.component';
import { ClickThrottle, DebouncedSearch } from '@shared/util/debounced-search.util';

@Component({
  selector: 'app-entidade-list',
  templateUrl: './entidade-list.component.html',
  styleUrls: ['./entidade-list.component.scss']
})
export class EntidadeListComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('justificativaModal') justificativaModal!: JustificativaModalComponent;


  dataSet: EntidadeElement[] = [];
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;

  entidadeFilterForm!: FormGroup;
  filtro: EntidadeFiltro = new EntidadeFiltro();
  roleEnum = RoleEnum;
  columOrder: ColumnOrder | undefined;

  sortCriteria: SortCriterion[] = [];
  private shiftPressed = false;
  private lastSortKey: string | null = null;

  statusEntidade: any[] = [];
  empresas: any[] = [];
  statusEntidades: any[] = [];
  perfilEnum = PerfilEnum;

  validaDetrans: any;
  size: NzButtonSize = 'large';
  situacoes: any[] = [];
  tiposEntidade: any[] = [];
  entidadesSuperior: any;
  searchChange$ = new BehaviorSubject('');
  optionList: string[] = [];
  gruposEconomico: any[] = [];
  tiposOrgao: any[] = [];
  gruposAtualizacao: any[] = [];
  tiposComissao: any[] = [];
  entidadesPertenceList: any[] = [];
  entidadeSuperiorList: any[] = [];
  tipoAssociadaList: any[] = [];
  subTipoList: any[] = [];
  cargoList: any[] = [];
  pesquisaInicialRealizada: boolean = false;
  mostrarSubTipoEntidade: boolean = false;
  mostrarCargo: boolean = false;

  nzpage = 0;
  total = 0;
  entidadeParaInativar!: EntidadeElement;
  nzFilterOption = (): boolean => true;

  loading = false;
  loadingTabela = false;
  private readonly buscaEntidadeDebounced = new DebouncedSearch();
  private readonly pesquisaThrottle = new ClickThrottle();
  private consultaSub?: Subscription;

  @HostListener('document:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent): void {
    event.preventDefault();
    this.pesquisar();
  }

  constructor(
    private dialogService: DialogService,
    private formBuilder: FormBuilder,
    private ngxPermissionService: NgxPermissionsService,
    private changeDetector: ChangeDetectorRef,
    public route: ActivatedRoute,

    private statusEntidadeService: StatusEntidadeService,
    private pessoaService: PessoaService,
    private entidadeService: EntidadesService,
    private messageService: MessageService,
    private router: Router,
    private modalService: NzModalService,
    private grupoEconomicoService: GrupoEconomicoService,
    private tipoEntidadeService: TipoEntidadeService,
    private situacaoEntidadeService: SituacaoEntidadeService,
    private entidadeSharedDataService: EntidadeSharedDataService,
    private appSignalDataService: AppSignalDataService,
    private tipoOrgaoService: TipoOrgaoService,
    private tipoComissaoService: TipoComissaoService,
    private grupoAtualizacaoService: GrupoAtualizacaoService,
    private tipoAssociacaoService: TipoAssociacaoService,
    private dominioService: DominiosService,
    private vinculoService: VinculoService,
  ) {
    this.appSignalDataService.updateCollapsedMenuAside(true);
  }

  ngAfterViewInit(): void {
    this.changeDetector.detectChanges();

    this.paginator.change.subscribe(() => {
      this.consultar();
    });

    this.consultar();
  }

  ngOnDestroy(): void {
    this.pesquisaThrottle.destroy();
    this.buscaEntidadeDebounced.cancelPending();
    this.consultaSub?.unsubscribe();
  }

  ngOnInit(): void {
    this.entidadeFilterForm = this.formBuilder.group({
      razaoSocial: [''],
      nomeFantasia: [''],
      situacao: [''],
      status: [''],
      grupoEconomico: [''],
      tipoEntidade: [],
      entidadeSuperior: [''],
      tipoOrgao: [],
      grupoAtualizacao: [],
      cnpj: [''],
      entidadePertenceId: [''],
      email: [''],
      tipoAssociacao: [''],
      subTipo: [''],
      cargo: [''],
    });

    this.grupoEconomicoService.listar().subscribe((data) => {
      this.gruposEconomico = data.sort((a: { nomeGrupoEconomico: string; }, b: { nomeGrupoEconomico: any; }) => a.nomeGrupoEconomico.localeCompare(b.nomeGrupoEconomico));
    });

    this.tipoEntidadeService.listar().subscribe((data) => {
      this.tiposEntidade = data;
    });

    this.statusEntidadeService.listar().subscribe((data) => {
      this.statusEntidade = data;
    });

    this.situacaoEntidadeService.listar().subscribe((data) => {
      this.situacoes = data;
    });

    this.entidadeSharedDataService.updateList$.subscribe(() => {
      this.consultar();
    });

    this.tipoOrgaoService.listar().subscribe((data) => {
      this.tiposOrgao = data;
    });

    this.grupoAtualizacaoService.listar().subscribe((data) => {
      this.gruposAtualizacao = data;
    });

    this.tipoComissaoService.listar().subscribe((data) => {
      this.tiposComissao = data;
    });

    this.entidadeService.entidadeRepresentacaoNacional().subscribe((data) => {
      this.entidadesPertenceList = (data ?? [])
        .filter((entidade: any) => entidade.representacaoId === 1)
        .sort((a: any, b: any) => (a.nomeFantasia ?? '').localeCompare(b.nomeFantasia ?? ''));
    });

    this.entidadeService.entidadeSuperiorCombo().subscribe((data) => {
      this.entidadeSuperiorList = data;
    });
    this.tipoAssociacaoService.list().subscribe((data) => {
      this.tipoAssociadaList = data;
    });

    this.subTipoControl.valueChanges.subscribe((val: number) => {
      this.mostrarCargo = !!val;
      this.cargoControl.reset();

      if (this.mostrarCargo) {
        this.dominioService.consultarCargoHierarquia(this.tipoEntidadeControl.value, val, null, false).subscribe({
          next: (cargos) => {
            this.cargoList = cargos;
          },
          error: () => {
            this.messageService.error('Erro ao carregar cargos');
            this.cargoList = [];
          }
        });
      }

      this.changeDetector.detectChanges();
    });

    this.tipoEntidadeControl.valueChanges.subscribe((val: number[]) => {
      this.mostrarSubTipoEntidade = val.length > 0;
      this.subTipoControl.reset();

      if (this.mostrarSubTipoEntidade) {
        this.tipoEntidadeService.listarSubTipos(val).subscribe({
          next: (subTipos) => {
            this.subTipoList = subTipos;
          },
          error: () => {
            this.messageService.error('Erro ao carregar subtipos');
            this.subTipoList = [];
          }
        });
      }

      this.changeDetector.detectChanges();
    });
  }

  private normalizarTexto(valor: string): string {
    return valor ? valor.toLowerCase().trim() : valor;
  }

  onSearch(value: string): void {
    this.loading = true;
    this.searchChange$.next(value);
  }

  loadEntidadesSuperior(value: string): void {
    this.buscaEntidadeDebounced.run(value, (termo) =>
      this.entidadeService.getEntidadeSuperiorList(termo).subscribe(data =>
        this.entidadesSuperior = data));
  }


  pesquisar(): void {
    this.pesquisaThrottle.run(() => this.executarPesquisa());
  }

  private executarPesquisa(): void {
    const formValue = this.entidadeFilterForm.value;

    this.filtro = {
      ...formValue,
      razaoSocial: this.normalizarTexto(formValue.razaoSocial),
      nomeFantasia: this.normalizarTexto(formValue.nomeFantasia),
      email: formValue.email,
      cnpj: this.normalizarTexto(formValue.cnpj)
    };

    this.paginator.reset();
    this.consultar();
  }

  consultar(): void {
    this.consultaSub?.unsubscribe();
    this.loadingTabela = true;
    this.consultaSub = this.entidadeService.consultarSort(
      this.filtro,
      this.paginator.pagination,
      sortQueryParams(this.sortCriteria),
      true
    ).pipe(
      finalize(() => {
        this.loadingTabela = false;
      })
    ).subscribe((data) => {
      this.dataSet = data.content;
      this.paginator.totalItens = data.totalElements;
    });
  }

  rememberShift(event: MouseEvent, key: string): void {
    if (event.shiftKey) {
      event.preventDefault();
      window.getSelection()?.removeAllRanges();
    }
    this.shiftPressed = event.shiftKey;
    this.lastSortKey = key;
  }

  onColumnSort(key: string, order: NzTableSortOrder): void {
    if (!order && key !== this.lastSortKey) {
      return;
    }
    this.sortCriteria = applyColumnSort(this.sortCriteria, key, order, this.shiftPressed);
    this.shiftPressed = false;
    this.paginator.reset();
    this.consultar();
  }

  sortOrderOf(key: string): NzTableSortOrder {
    return columnSortOrder(this.sortCriteria, key);
  }

  sortPriorityOf(key: string): number | null {
    return columnSortPriority(this.sortCriteria, key);
  }

  novo(): void {
    this.limparCache();
    this.router.navigate(['/entidade/cadastrar']);
  }

  editar(obj: EntidadeElement): void {
    this.limparCache();
    if (this.ngxPermissionService.getPermission(RoleEnum.EntidadeEdicao)) {
      this.router.navigate([`/entidade/editar/${obj.id}`]);
    } else {
      this.router.navigate([`/entidade/visualizar/${obj.id}`]);
    }
  }

  filter(obj: EntidadeElement, acao: string): void {
    switch (acao) {
      case 'INATIVAR':
        this.showModal(obj);
        break;
      case 'ATIVAR':
        this.ativar(obj);
        break;
      default:
        break;
    }
  }

  exibirAtivar(obj: EntidadeElement) {
    return obj.excluido === true;
  }

  exibirInativar(obj: EntidadeElement) {
    return obj.excluido === false;
  }

  showModal(obj?: any): void {
    this.vinculoService.listarPorVinculoEntidade(obj.id, false).subscribe((data) => {
      if (data.length > 0) {
        const modal: any = this.modalService.create<ModalErro409Component>({
          nzTitle: 'Atenção!',
          nzWidth: 800,
          nzStyle: { top: '10vh' },
          nzBodyStyle: {
            'max-height': '70vh',
            'overflow-y': 'auto'
          },
          nzContent: ModalErro409Component,
          nzData: {
            itens: data.map((item: any) => `Pessoa ${item.descricao}`)
          },
          nzFooter: [
            {
              label: 'Fechar',
              type: 'primary',
              onClick: () => modal.destroy()
            }
          ],
          nzClosable: true,
          nzMaskClosable: true
        });

        modal.componentInstance!.tituloSingular = 'Não é possível inativar esta entidade pois ela possui vínculo ativo.';
        modal.componentInstance!.tituloPlural = 'Não é possível inativar esta entidade pois ela possui vínculos ativos.';
      } else {
        const config: ModalOptions<JustificativaModalComponent> = {
          nzTitle: 'Informe a Justificativa: ',
          nzContent: JustificativaModalComponent,
          nzCentered: true,
          nzFooter: null,
          nzMaskClosable: false,
          nzWidth: '30vw',
          nzClosable: false
        };

        const modalRef = this.modalService.create(config);

        modalRef.afterClose.subscribe((justificativa: any) => {
          if (justificativa) {
            if (obj) {
              this.inativar(obj, justificativa);
            }
          }
        });
      }
    })
  }

  inativar(obj: EntidadeElement, justificativa: string): void {
    const object = {
      idEntidade: obj.id,
      idStatus: 2,
      justificativa: justificativa
    };
    this.entidadeService.alterarStatus(object).subscribe(() => {
      this.messageService.success('Entidade Excluida com sucesso');
      this.consultar();
    });
  }

  ativar(obj: EntidadeElement): void {
    const object = {
      idEntidade: obj.id,
      idStatus: 1,
      justificativa: 'Ativação de entidade'
    };
    this.entidadeService.alterarStatus(object).subscribe(() => {
      this.messageService.success('Entidade Reativada com sucesso');
      this.consultar();
    });
  }

  limparCache(): void {
    localStorage.removeItem('dadosBasicos');
    localStorage.removeItem('dadosContato');
    localStorage.removeItem('observacao');
    localStorage.removeItem('grupos');
    localStorage.removeItem('documentos');
  }

  statusInativo(status: string): boolean {
    return status != 'Ativa';
  }

  exportar() {
    // this.arquivoService.downloadArquivo().subscribe(
    //   (response: any) => {
    //     let fileName = response.headers.get('filename');
    //     FileSaver.saveAs(response.body, fileName);
    //   }
    // );
  }

  resetForm(): void {
    this.entidadeFilterForm.reset();
    this.filtro = new EntidadeFiltro();
    this.paginator.reset();
    this.consultar();
  }

  get tipoEntidadeControl(): any {
    return this.entidadeFilterForm?.get('tipoEntidade');
  }

  get subTipoControl(): any {
    return this.entidadeFilterForm?.get('subTipo');
  }

  get cargoControl(): any {
    return this.entidadeFilterForm?.get('cargo');
  }
}
